export default {"src":"/_next/static/media/revive.179bd9ca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};